import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { GameState, Store, Resources } from '../../interfaces/game.interface';
import { Observable } from 'rxjs';
import { DataService } from '../../services/data.service';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-shop-page',
  templateUrl: './shop-page.component.html',
  styleUrls: ['./shop-page.component.scss']
})
export class ShopPageComponent implements OnInit {
  @Input() shopId: string;
  @Output() closeClick = new EventEmitter<void>();
  shop$: Observable<Store>;
  resourcesLeft$: Observable<Resources>;
  quarter: string | null = null;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.shop$ = this.dataService.gameState$.pipe(
      filter((state): state is GameState => state !== null), // Type guard
      map(state => state.stores[this.shopId]),
      filter((shop): shop is Store => !!shop) // Ensure shop exists
    )

    this.resourcesLeft$ = this.dataService.getResourceLimitsLeft();

    setTimeout(() => this.initializeQuarter(), 100);
  }

  initializeQuarter() {
    const currentState = this.dataService.getGameStateSnapshot();
    if (!currentState) return;

    this.quarter = currentState.game_state;
  }
  
  assignTime(value: number) {
    const update = { time: value };
    this.assign(update);
  }

  assignTposm(type: string, value: number) {
    const tposm = {'tposm_p1': 0, 'tposm_p4': 0, 'tposm_p5': 0, 'tposm_full': 0};
    tposm[type] = value;
    this.assign(tposm);
  }

  assignMcc(value: number) {
    const update = { mcc: value };
    this.assign(update);
  }

  assignIncentives(value: number) {
    const update = { incentives: value };
    this.assign(update);
  }

  assign(update: any) {
    const currentState = this.dataService.getGameStateSnapshot();
    if (!currentState) return;
  
    const shop = currentState.stores[this.shopId];
    if (!shop) return;

    const quarter = currentState.game_state;

    const updatedResources = {
      ...shop.resources[quarter],
      ...update
    };
  
    this.dataService.updateShopResources(this.shopId, updatedResources, quarter);
  }

  getStatColor(prev: number, current: number, gain: boolean = true) {
    if (current > prev) {
      if (gain) {
        return "#51B154";
      } else {
        return "#ED1C24";
      }
    } else if (prev > current) {
      if (gain) {
        return "#ED1C24";
      } else {
        return "#51B154";
      }
    }
    return "grey";
  }

  getPrevQuarter(quarter: string) {
    if (quarter) {
      return "q" + (Number(quarter.slice(1, 2)) - 1);
    }
    return "q2";
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
